import { useTranslation } from 'react-i18next';
import type { ApplicationPosition } from '@/api/types.ts';

export const usePositionNameGetter = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  return (position: ApplicationPosition) => {
    if (language === 'es' && position.name_spanish) {
      return position.name_spanish;
    }

    return position.name;
  };
};
